module.exports = __webpack_public_path__ + "img/partC1.0c213a3f.png";